"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extensionsAllowedForExtraction = exports["default"] = void 0;
Object.defineProperty(exports, "firebaseAdesc", {
  enumerable: true,
  get: function get() {
    return _firebaseConfig["default"];
  }
});
Object.defineProperty(exports, "firebaseBeta", {
  enumerable: true,
  get: function get() {
    return _firebaseConfig2["default"];
  }
});
Object.defineProperty(exports, "firebaseNewton", {
  enumerable: true,
  get: function get() {
    return _firebaseConfig3["default"];
  }
});
Object.defineProperty(exports, "mainFirebaseAdesc", {
  enumerable: true,
  get: function get() {
    return _firebaseConfig.firebase;
  }
});
Object.defineProperty(exports, "mainFirebaseBeta", {
  enumerable: true,
  get: function get() {
    return _firebaseConfig2.firebase;
  }
});
Object.defineProperty(exports, "mainFirebaseNewton", {
  enumerable: true,
  get: function get() {
    return _firebaseConfig3.firebase;
  }
});
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _firebaseConfig = _interopRequireWildcard(require("./firebase.config.adesc"));
var _firebaseConfig2 = _interopRequireWildcard(require("./firebase.config.beta"));
var _firebaseConfig3 = _interopRequireWildcard(require("./firebase.config.newton"));
var _axios = _interopRequireDefault(require("axios"));
var _store = require("../store");
var _common = require("../common");
var _functions = require("./functions");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var instances = {
  adesc: _firebaseConfig["default"],
  beta: _firebaseConfig2["default"],
  newton: _firebaseConfig3["default"]
};
var storeKey = '@K#App$dokia';
var types = {
  update: 'dokia-'
};
var storedState = JSON.parse(localStorage.getItem(storeKey)) || {};
var createInitialState = function createInitialState(storedState) {
  return _objectSpread({}, storedState);
};
var INITIAL_STATE = createInitialState(storedState);
var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var getState = function getState(oState, action) {
    switch (action.type) {
      default:
        return _objectSpread({}, oState);
    }
  };
  var finalState = getState(state, action);
  localStorage.setItem(storeKey, JSON.stringify(finalState));
  return finalState;
};
var getAppcenterStore = function getAppcenterStore() {
  return _store.store.getState().appcenter;
};
var isLocal = window.location.href.indexOf('localhost') > -1;
var api = function api() {
  var firebase = _firebaseConfig3["default"];
  var api = function api() {
    return _axios["default"].create({
      baseURL: isLocal ? firebase.options.projectId.indexOf('beta') == -1 ? "http://localhost:5006/".concat(firebase.options.projectId, "/us-central1/api") : 'http://localhost:5006/dokiabeta/us-central1/api' : "https://us-central1-".concat(firebase.options.projectId, ".cloudfunctions.net/api"),
      timeout: 240000
    });
  };
  var axiosInstance = api();
  var documentCollection = function documentCollection() {
    return firebase.firestore().collection('document');
  };
  var organizationalItemCollection = function organizationalItemCollection() {
    return firebase.firestore().collection('organizationalItem');
  };
  var classificationCollection = function classificationCollection() {
    return firebase.firestore().collection('classification');
  };
  var entityCollection = function entityCollection() {
    return firebase.firestore().collection('classification');
  };
  var guardItemCollection = function guardItemCollection() {
    return firebase.firestore().collection('classification');
  };
  var service = {
    axios: function axios() {
      return axiosInstance;
    },
    current: function current() {
      return firebase.options.projectId.replace('dokia-', '');
    },
    instance: function instance(client) {
      firebase = instances[client];
      return firebase;
    },
    auth: {
      login: {
        token: function token(_token) {
          return firebase.auth().signInWithCustomToken(_token);
        },
        multiple: {
          adesc: function adesc(token) {
            return instances['adesc'].auth().signInWithCustomToken(token);
          },
          newton: function newton(token) {
            return instances['newton'].auth().signInWithCustomToken(token);
          }
        }
      },
      logout: function () {
        var _logout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return instances['adesc'].auth().signOut();
              case 2:
                _context.next = 4;
                return instances['newton'].auth().signOut();
              case 4:
                return _context.abrupt("return", Promise.resolve());
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function logout() {
          return _logout.apply(this, arguments);
        }
        return logout;
      }()
    },
    document: {
      validate: function validate(document) {
        var valid = true;
        if (!document) return false;
        if (document.meta.fields) {
          Object.values(document.meta.fields).map(function (oEntity) {
            Object.values(oEntity.fields).map(function (field) {
              if (!field.required) return;
              if (!field.value) {
                valid = false;
              }
            });
          });
          if (document.size == 0 && !document.meta.box) {
            valid = false;
          }
        } else {
          valid = false;
        }
        document.valid = valid;
        return valid;
      },
      save: function () {
        var _save = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref) {
          var hierarchy, file, onProgressUpdate, appcenterStore, validation, parent, path;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                hierarchy = _ref.hierarchy, file = _ref.file, onProgressUpdate = _ref.onProgressUpdate;
                appcenterStore = getAppcenterStore();
                if (appcenterStore.authenticated) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return", Promise.reject());
              case 4:
                if (!file.meta) {
                  file.meta = {
                    fields: {},
                    box: ''
                  };
                }
                validation = service.document.validate(file);
                file.valid = validation;
                if (!(!file.valid || !file.size)) {
                  _context2.next = 9;
                  break;
                }
                return _context2.abrupt("return", Promise.reject());
              case 9:
                parent = hierarchy[hierarchy.length - 1];
                path = appcenterStore.company.uid + '/' + hierarchy.map(function (o) {
                  return o.code;
                }).join('/');
                if (!(file.progress > 0)) {
                  _context2.next = 13;
                  break;
                }
                return _context2.abrupt("return", Promise.reject());
              case 13:
                if (!file.meta.fields) {
                  file.meta.fields = {};
                }
                if (!file.meta.code) {
                  file.meta.code = (0, _functions.createDocumentCode)(hierarchy);
                }
                if (!file.meta.id) {
                  file.meta.id = (0, _common.smallUid)();
                }
                file.extension = file.name.split('.').pop();
                return _context2.abrupt("return", (0, _functions.upload)(firebase, path, file, function (p) {
                  file.progress = p;
                  if (typeof onProgressUpdate == 'function') onProgressUpdate(p, file);
                }, {
                  contentType: file.type,
                  cacheControl: 'public, max-age=31536000',
                  customMetadata: {
                    classification: parent.uid,
                    userid: appcenterStore.user.uid,
                    username: appcenterStore.user.firstName + '' + appcenterStore.user.lastName,
                    code: file.meta.code
                  }
                }).then(function (props) {
                  //('props', props)
                  file.meta.hash = props.meta.md5Hash;
                  file.meta.fullPath = props.meta.fullPath;
                  file.meta.lastRun = '';
                  Object.keys(file.meta.fields).map(function (key) {
                    delete file.meta.fields[key].$$index;
                  });
                  var doc = documentCollection().doc();
                  var oDocument = {
                    company: appcenterStore.company.uid,
                    createdBy: appcenterStore.user.uid,
                    createdAt: new Date(),
                    deleted: false,
                    url: props.url,
                    path: path,
                    classification: parent.uid,
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    extension: file.extension || 'n/a',
                    meta: file.meta,
                    history: [],
                    uid: doc.id
                  };
                  if (file.extract) {
                    oDocument.extract = true;
                  }
                  return doc.set(oDocument).then(function (r) {
                    //('FILE', oDocument)
                    (0, _functions.registerUpload)(axiosInstance)({
                      file: oDocument,
                      user: appcenterStore.user.uid,
                      userName: appcenterStore.user.firstName + ' ' + appcenterStore.user.lastName
                    });
                  });
                }));
              case 18:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function save(_x) {
          return _save.apply(this, arguments);
        }
        return save;
      }()
    },
    oi: {
      organization: {
        list: function list() {
          var appcenterStore = getAppcenterStore();
          if (!appcenterStore.authenticated) return;
          return organizationalItemCollection().where('company', '==', appcenterStore.company.uid).where('deleted', '==', false).where('type', '==', 'organization').get().then(function (snapshot) {
            return snapshot.docs.map(function (d) {
              return d.data();
            });
          });
        }
      },
      company: {
        list: function list(parent) {
          var appcenterStore = getAppcenterStore();
          if (!appcenterStore.authenticated) return;
          return organizationalItemCollection().where('company', '==', appcenterStore.company.uid).where('deleted', '==', false).where('type', '==', 'company').where('parent', '==', parent).get().then(function (snapshot) {
            return snapshot.docs.map(function (d) {
              return d.data();
            });
          });
        }
      },
      subsidiary: {
        list: function list(parent) {
          var appcenterStore = getAppcenterStore();
          if (!appcenterStore.authenticated) return;
          return organizationalItemCollection().where('company', '==', appcenterStore.company.uid).where('deleted', '==', false).where('type', '==', 'subsidiary').where('parent', '==', parent).get().then(function (snapshot) {
            return snapshot.docs.map(function (d) {
              return d.data();
            });
          });
        }
      },
      classification: {
        list: function list(parent) {
          var appcenterStore = getAppcenterStore();
          if (!appcenterStore.authenticated) return;
          return classificationCollection().where('company', '==', appcenterStore.company.uid).where('deleted', '==', false).where('parent', '==', parent).get().then(function (snapshot) {
            return snapshot.docs.map(function (d) {
              return d.data();
            });
          });
        },
        get: function get(uid) {
          var appcenterStore = getAppcenterStore();
          if (!appcenterStore.authenticated) return;
          return classificationCollection().doc(uid).get().then(function (doc) {
            return doc.exists ? doc.data() : false;
          });
        }
      },
      entity: {
        list: function list() {
          var appcenterStore = getAppcenterStore();
          if (!appcenterStore.authenticated) return;
          return classificationCollection().where('company', 'in', [appcenterStore.company.uid, 'all']).where('deleted', '==', false).get().then(function (snapshot) {
            return snapshot.docs.map(function (d) {
              return d.data();
            });
          });
        }
      }
    }
  };
  return service;
};
var extensionsAllowedForExtraction = ['HTML', 'HTM', 'ATOM', 'RSS', 'MD', 'EPUB', 'XML', 'XSL', 'PDF', 'DOC', 'DOCX', 'ODT', 'OTT', 'RTF', 'XLS', 'XLSX', 'XLSB', 'XLSM', 'XLTX', 'CSV', 'ODS', 'OTS', 'PPTX', 'POT', 'ODP', 'OTP', 'ODG', 'OTG', 'PNG', 'JPG', 'GIF', 'JS', 'TXT'];
exports.extensionsAllowedForExtraction = extensionsAllowedForExtraction;
var dokia = api();
_store.store.injectReducer('dokia', reducer, dokia);
var _default = dokia;
exports["default"] = _default;